module.exports = __webpack_public_path__ + "static/media/aws.202e4b2f.svg";